// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__1DJsC","icon":"switch_icon__3agHb"};